import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { RoleType, CacheService } from 'mapfre-auditlib';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROLES_TREE } from './roles-tree';

@Injectable({
  providedIn: 'root'
})
export class RoleTypeService {

  className = 'RoleTypeService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllRoles(cache = true, cacheKey = "allRoles"): Observable<RoleType[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<RoleType[]>(environment.base_URL + "/roles-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  removeById(array) {
    array.forEach(element => {
      delete element.id;
    });
    return array;
  }
}
